import { useQuery } from "@tanstack/react-query";
import { replaceUriParameter, RestEndpoints } from "../../api/endpoints";
import { ReactQueryConfig } from "../../config/react-query-config";
import getInstance from "../../utils/rest";
import { IPomAgencyGroupListModel } from "../models/agencies/pom-agency-groups.model";
import { PomQueryKeys } from "../pom-query-keys";

const getAgencyCompanies = async (
  erpNumber: string | undefined,
  page: number,
  pageSize: number,
  memberErpQuery?: string,
  memberNameQuery?: string,
): Promise<IPomAgencyGroupListModel | undefined> => {
  if (!erpNumber) {
    return undefined;
  }
  const url = replaceUriParameter(RestEndpoints.PomAgencyGroups, "erpNumber", erpNumber);
  const { data } = await getInstance().get<IPomAgencyGroupListModel>(url, {
    params: {
      page: page,
      pageSize: pageSize,
      memberErpQuery: memberErpQuery,
      memberNameQuery: memberNameQuery,
    },
  });

  return data;
};

export const useGetAgencyCompaniesQuery = (erpNumber: string | undefined, page: number, pageSize: number, memberErpQuery?: string, memberNameQuery?: string) => {
  return useQuery({
    queryKey: [PomQueryKeys.GetAgencyCompanies, erpNumber, page, pageSize, memberErpQuery, memberNameQuery],
    queryFn: () => getAgencyCompanies(erpNumber, page, pageSize, memberErpQuery, memberNameQuery),
    staleTime: ReactQueryConfig.staleTime,
  });
};
